/* eslint-disable */
import React from "react";
import { last, first } from 'lodash';
import { CalendarYear } from '../../../controls/CalendarYear';

export const CalendarControl: React.FC = () => {
    return <CalendarYear allYear multiple parameter="@calendar" dictionary="calendar-stocktouseratio"  />;
};
